import { Tooltip } from 'antd';
import { CSSProperties } from 'react';
import styled from 'styled-components';

import { InfoCircleOutlined } from '@ant-design/icons';

import { BodilColor } from '~src/branding';
import { Heading, Text } from '~src/components/Typography';
import { useSelectedProductTypesContext } from '~src/context/selectedProductTypeContext';
import { formatCurrency, getOutputArrayFilteredByProductType } from '~src/util';
import { CALCULATION_DISCLAIMER } from '~src/constants';

const SavingsText = styled.span({
  fontSize: '28px',
  fontWeight: 600,
  color: BodilColor.ui.orange,
});

type HeaderStreamerProps = {
  style?: CSSProperties;
  totalSaved?: number;
  showLoan?: boolean;
};

export const HeaderStreamer = ({ style, totalSaved = 0, showLoan }: HeaderStreamerProps) => {
  const { selectedProductTypes } = useSelectedProductTypesContext();

  const products = getOutputArrayFilteredByProductType(selectedProductTypes, 'en varmepumpe', 'solceller');

  const hasSolar = selectedProductTypes.includes('solar');
  const disclaimer =
    selectedProductTypes.length > 1
      ? ''
      : hasSolar
        ? 'Sparer du mere end din nuværende elregning, betyder det, at du tjener ekstra penge ved salg af strøm.'
        : 'Hvis du sparer mere end din nuværende varmeregning, skyldes det, at du får en reduceret el-takst når du har en varmepumpe.';

  return (
    <div style={{ height: 'fit-content', ...style }}>
      <Text level={2} color='light'>
        {disclaimer}
      </Text>
      <Heading style={{ fontSize: '24px', marginTop: '12px' }} color='light'>
        Bodil estimerer, at du kan
        <SavingsText>&nbsp;spare {formatCurrency(totalSaved, { decimals: 0 })}&nbsp;</SavingsText>
        årligt {showLoan ? '(ekskl. bankydelse)' : ''} med {products.join(' og ')}&nbsp;
        <Tooltip title={CALCULATION_DISCLAIMER}>
          <InfoCircleOutlined />
        </Tooltip>
      </Heading>
    </div>
  );
};
